import { LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    changeWeek,
    myAxios,
    MyDate,
    standbyWeeks,
    weeknum,
} from "src/components/common/functions";

export async function standbyLoader({ params }: LoaderFunctionArgs) {
    const fallbackWeek = weeknum(new MyDate().s());
    const selectedWeek = params.week && standbyWeeks.includes(params.week) ? params.week : fallbackWeek;
    if (params.week !== selectedWeek) {
        throw redirect(`/StandbyTimeCard/${selectedWeek}`);
    }

    const prevWeek = changeWeek(selectedWeek, -1);
    const formData = new FormData();
    formData.append("week", selectedWeek);
    if (prevWeek !== "w2023-28") {
        formData.append("prevWeek", prevWeek);
    }
    const res = await myAxios({ fileName: "outside/standby/readTimeCard.php", formData });
    if (!res) throw redirect("/");

    return {
        week: selectedWeek,
        form: JSON.parse(res.data?.[selectedWeek] || "{}"),
        prevForm: prevWeek !== "w2023-28" ? JSON.parse(res.data?.[prevWeek] || "{}") : undefined,
    };
}
